import { render, staticRenderFns } from "./SoftwareDetail.vue?vue&type=template&id=a04b52ba&scoped=true&"
import script from "./SoftwareDetail.vue?vue&type=script&lang=js&"
export * from "./SoftwareDetail.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareDetail.vue?vue&type=style&index=0&id=a04b52ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04b52ba",
  null
  
)

export default component.exports